{
  "pending": "в ожидании"
}
